document.addEventListener('DOMContentLoaded', () => {
  const messageField = document.querySelector('[data-restock-contact]');
  if (!messageField) return;

  const params = new URLSearchParams(window.location.search);
  if (params.get('inquiry') !== 'restock') return;

  const product = params.get('product')?.trim().slice(0, 200);
  const variant = params.get('variant')?.trim().slice(0, 200);
  const productUrlParam = params.get('product_url')?.trim();
  if (!product) return;

  let productUrl = '';
  if (productUrlParam) {
    try {
      const parsedUrl = new URL(productUrlParam, window.location.origin);
      if (parsedUrl.origin === window.location.origin) productUrl = parsedUrl.href;
    } catch {
      productUrl = '';
    }
  }

  const context = [
    [messageField.dataset.restockTypeLabel, messageField.dataset.restockTypeValue],
    [messageField.dataset.restockProductLabel, product],
  ];

  if (variant) context.push([messageField.dataset.restockVariantLabel, variant]);
  if (productUrl) context.push([messageField.dataset.restockProductUrlLabel, productUrl]);

  messageField.placeholder = messageField.dataset.restockPlaceholder;

  if (!messageField.value.trim()) {
    messageField.value = `${context.map(([label, value]) => `${label}: ${value}`).join('\n')}\n\n${
      messageField.dataset.restockPrompt
    }:\n`;
  }

  const form = messageField.closest('form');
  if (!form) return;

  context.forEach(([label, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `contact[${label}]`;
    input.value = value;
    form.appendChild(input);
  });
});
